export enum SifSectionName {
  JobDetails = 'job-details',
  SiteInformation = 'site-information',
  HSE = 'hse',
  SiteDiagram = 'site-diagram',
}